module.exports = __webpack_public_path__ + "img/75750.f045c696.svg";